<h2 mat-dialog-title>{{ data?.title }}</h2>
<mat-dialog-content>{{ data?.body }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>ביטול</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button [mat-dialog-close]="true">אישור</button>
</mat-dialog-actions>